export enum IconColor {
  GRAY_200 = '--lia-bs-gray-200',
  GRAY_300 = '--lia-bs-gray-300',
  GRAY_400 = '--lia-bs-gray-400',
  GRAY_500 = '--lia-bs-gray-500',
  GRAY_600 = '--lia-bs-gray-600',
  GRAY_700 = '--lia-bs-gray-700',
  GRAY_800 = '--lia-bs-gray-800',
  GRAY_900 = '--lia-bs-gray-900',
  BLACK = '--lia-bs-black',
  BODY_COLOR = '--lia-bs-body-color',
  WHITE = '--lia-bs-white',
  PRIMARY = '--lia-bs-primary',
  PRIMARY_DARK = '--lia-primary-dark',
  SECONDARY = '--lia-bs-secondary',
  INFO = '--lia-bs-info',
  SUCCESS = '--lia-bs-success',
  WARNING = '--lia-bs-warning',
  WARNING_DARK = '--lia-warning-dark',
  DANGER = '--lia-bs-danger',
  LIGHT = '--lia-bs-light',
  LINK_COLOR = '--lia-bs-link-color',
  DARK = '--lia-bs-dark',
  SYSTEM = '--lia-alert-system-color',
  FORUM = '--lia-forum-color',
  QUESTION = '--lia-qanda-color',
  SOLVED = '--lia-forum-solved-color',
  BLOG = '--lia-blog-color',
  KNOWLEDGE = '--lia-tkb-color',
  OCCASION = '--lia-occasion-color',
  IDEA = '--lia-idea-color',
  CONTEST = '--lia-contest-color',
  GROUP = '--lia-group-color',
  CATEGORY = '--lia-category-color',
  GROUPHUB = '--lia-grouphub-color',
  PRODUCT = '--lia-product-color',
  COMMUNITY = '--lia-community-color',
  IMAGE_PREVIEW_CONTROL = '--lia-img-preview-control-color',
  LOAD_TEXT = '--lia-load-text-color',
  NAV_CONTROLLER = '--lia-nav-controller-icon-color'
}

export enum IconSize {
  PX_12 = '12',
  PX_14 = '14',
  PX_16 = '16',
  PX_20 = '20',
  PX_24 = '24',
  PX_30 = '30',
  PX_40 = '40',
  PX_50 = '50',
  PX_80 = '80',
  PX_120 = '120',
  PX_160 = '160'
}

/**
 * This is a subset of the Icons for use in React Components.
 */
export enum IconTypes {
  AccessibilityIcon = 'accessibility',
  AddIcon = 'add',
  AddOutlineIcon = 'add-outline',
  AddSolidIcon = 'add-solid',
  AddSolidOutlineIcon = 'add-solid-outline',
  AiIcon = 'ai',
  AnalyticsDashboardsIcon = 'analytics-dashboards',
  AnalyticsReportsIcon = 'analytics-reports',
  AnalyticsThirdpartyIcon = 'analytics-thirdparty',
  AnchorIcon = 'anchor',
  AnnouncementIcon = 'announcement',
  ArchiveIcon = 'archive',
  ArchiveOutlineIcon = 'archive-outline',
  ArchivedIcon = 'archived',
  ArrowDownIcon = 'arrow-down',
  ArrowDownOutlineIcon = 'arrow-down-outline',
  ArrowLeftIcon = 'arrow-left',
  ArrowLeftOutlineIcon = 'arrow-left-outline',
  ArrowRightIcon = 'arrow-right',
  ArrowRightOutlineIcon = 'arrow-right-outline',
  ArrowUpIcon = 'arrow-up',
  ArrowUpOutlineIcon = 'arrow-up-outline',
  ArrowUpRightIcon = 'arrow-up-right',
  AttachmentIcon = 'attachment',
  AttachmentOutlineIcon = 'attachment-outline',
  AutosaveIcon = 'autosave',
  AutosaveOutlineIcon = 'autosave-outline',
  BadgeUnknownIcon = 'badge-unknown',
  BadgesIcon = 'badges',
  BasicsWidthofbrowserIcon = 'basics-widthofbrowser',
  BasicsWidthofpageIcon = 'basics-widthofpage',
  BellIcon = 'bell',
  BinocularsIcon = 'binoculars',
  BrowserBrowserWidthIcon = 'browser-browser-width',
  BrowserFluidWidthIcon = 'browser-fluid-width',
  BrowserPageContentWidthIcon = 'browser-page-content-width',
  ButtonHeroIcon = 'button-hero',
  ButtonLargeIcon = 'button-large',
  ButtonStandardIcon = 'button-standard',
  ButtonsFilledIcon = 'buttons-filled',
  ButtonsOutlinedIcon = 'buttons-outlined',
  ButtonsPillIcon = 'buttons-pill',
  ButtonsSquareIcon = 'buttons-square',
  CategoryCommonIcon = 'category-common',
  CategoryContentIcon = 'category-content',
  CategoryCustomIcon = 'category-custom',
  CategoryPeopleIcon = 'category-people',
  CategoryPlacesIcon = 'category-places',
  CategoryTextHtmlIcon = 'category-text-html',
  ChapterIcon = 'chapter',
  CheckmarkAdminIcon = 'checkmark-admin',
  CheckmarkIcon = 'checkmark',
  CheckmarkInputIcon = 'checkmark-input',
  CheckmarkOutlineIcon = 'checkmark-outline',
  CheckmarkSolidIcon = 'checkmark-solid',
  CheckmarkSolidOutlineIcon = 'checkmark-solid-outline',
  ChevronDownIcon = 'chevron-down',
  ChevronDownOutlineIcon = 'chevron-down-outline',
  ChevronLeftIcon = 'chevron-left',
  ChevronLeftOutlineIcon = 'chevron-left-outline',
  ChevronRightIcon = 'chevron-right',
  ChevronRightOutlineIcon = 'chevron-right-outline',
  ChevronUpIcon = 'chevron-up',
  ChevronUpOutlineIcon = 'chevron-up-outline',
  CloseIcon = 'close',
  CloseOutlineIcon = 'close-outline',
  CommentIcon = 'comment',
  CommentOutlineIcon = 'comment-outline',
  CommunityIcon = 'community',
  ContentBlogIcon = 'content-blog',
  ContentCategoryIcon = 'content-category',
  ContentContestIcon = 'content-contest',
  ContentDiscussionIcon = 'content-discussion',
  ContentDiscussionQuestionIcon = 'content-discussion-question',
  ContentDiscussionSolvedIcon = 'content-discussion-solved',
  ContentGroupIcon = 'content-group',
  ContentIdeaIcon = 'content-idea',
  ContentKnowledgeIcon = 'content-knowledge',
  ContentLayoutCardIcon = 'content-layout-card',
  ContentLayoutDetailedListIcon = 'content-layout-detailed-list',
  ContentLayoutListIcon = 'content-layout-list',
  ContentOccasionIcon = 'content-occasion',
  ContentProductIcon = 'content-product',
  ContentTagIcon = 'content-tag',
  CoreRoleIcon = 'core-role',
  CreateIcon = 'create',
  CreateOutlineIcon = 'create-outline',
  DangerAdminIcon = 'danger-admin',
  DangerIcon = 'danger',
  DangerOutlineIcon = 'danger-outline',
  DesignerAssetsIcon = 'designer-assets',
  DesignerChangelogIcon = 'designer-changelog',
  DesignerEmailsIcon = 'designer-emails',
  DesignerPagesIcon = 'designer-pages',
  DesignerTextkeysIcon = 'designer-textkeys',
  DesignerThemesIcon = 'designer-themes',
  DeviceDesktopIcon = 'device-desktop',
  DevicePhoneIcon = 'device-phone',
  DeviceTabletIcon = 'device-tablet',
  DownloadIcon = 'download',
  DownloadOutlineIcon = 'download-outline',
  DragIcon = 'drag',
  DragLockIcon = 'drag-lock',
  DragMoveIcon = 'drag-move',
  EditIcon = 'edit',
  EditOutlineIcon = 'edit-outline',
  EditRedoIcon = 'edit-redo',
  EditUndoIcon = 'edit-undo',
  ElementsBordersDarkIcon = 'elements-borders-dark',
  ElementsBordersLightIcon = 'elements-borders-light',
  ElementsBordersNoneIcon = 'elements-borders-none',
  ElementsInputsPillIcon = 'elements-inputs-pill',
  ElementsInputsRoundedIcon = 'elements-inputs-rounded',
  ElementsInputsSquareIcon = 'elements-inputs-square',
  ElementsModalsDarkIcon = 'elements-modals-dark',
  ElementsModalsLightIcon = 'elements-modals-light',
  ElementsRadiusLargeIcon = 'elements-radius-large',
  ElementsRadiusSmallIcon = 'elements-radius-small',
  ElementsRadiusSquareIcon = 'elements-radius-square',
  ElementsShadowsDarkIcon = 'elements-shadows-dark',
  ElementsShadowsLightIcon = 'elements-shadows-light',
  ElementsShadowsNoneIcon = 'elements-shadows-none',
  EllipsisIcon = 'ellipsis',
  EllipsisOutlineIcon = 'ellipsis-outline',
  EmojiActivityIcon = 'emoji-activity',
  EmojiAnimalsAndNatureIcon = 'emoji-animals-and-nature',
  EmojiCustomIcon = 'emoji-custom',
  EmojiFlagsIcon = 'emoji-flags',
  EmojiFoodAndDrinkIcon = 'emoji-food-and-drink',
  EmojiObjectsIcon = 'emoji-objects',
  EmojiSmileysAndPeopleIcon = 'emoji-smileys-and-people',
  EmojiSymbolsIcon = 'emoji-symbols',
  EmojiTravelAndPlacesIcon = 'emoji-travel-and-places',
  EnvelopeIcon = 'envelope',
  ExternalLinkIcon = 'external-link',
  ExternalLinkOutlineIcon = 'external-link-outline',
  FaceHappyIcon = 'face-happy',
  FaceHappyOutlineIcon = 'face-happy-outline',
  FaceSadIcon = 'face-sad',
  FaceSadOutlineIcon = 'face-sad-outline',
  FeaturesFeaturesIcon = 'features-features',
  FeaturesInboxIcon = 'features-inbox',
  FeaturesLocalizedCategoriesIcon = 'features-localized-categories',
  FeaturesModerationIcon = 'features-moderation',
  FeaturesProductsIcon = 'features-products',
  FeaturesSalesforceIcon = 'features-salesforce',
  FeaturesSyndicationIcon = 'features-syndication',
  FilterIcon = 'filter',
  FlagAdminIcon = 'flag-admin',
  FlagIcon = 'flag',
  FlagOutlineIcon = 'flag-outline',
  FollowIcon = 'follow',
  FollowOutlineIcon = 'follow-outline',
  FollowingIcon = 'following',
  FollowingOutlineIcon = 'following-outline',
  FollowsEmptyIcon = 'follows-empty',
  GearIcon = 'gear',
  GearOutlineIcon = 'gear-outline',
  GuideIcon = 'guide',
  HamburgerMenuIcon = 'hamburger-menu',
  HeaderLargeIcon = 'header-large',
  HeaderMediumHomeIcon = 'header-medium-home',
  HeaderMediumPlaceIcon = 'header-medium-place',
  HeaderSmallIcon = 'header-small',
  HelpIcon = 'help',
  HomeIcon = 'home',
  InboxIcon = 'inbox',
  InboxOutlineIcon = 'inbox-outline',
  InfoAdminIcon = 'info-admin',
  InfoIcon = 'info',
  InfoOutlineIcon = 'info-outline',
  KeyIcon = 'key',
  KhorosCurlIcon = 'khoros-curl',
  KhorosFullLogoIcon = 'khoros-full-logo',
  KhorosLogoIcon = 'khoros-logo',
  LanguageIcon = 'language',
  LayoutCardIcon = 'layout-card',
  LayoutClusterIconIcon = 'layout-cluster-icon',
  LayoutGridIcon = 'layout-grid',
  LayoutListIcon = 'layout-list',
  LikeIcon = 'like',
  LikeOutlineIcon = 'like-outline',
  LikeRemoveIcon = 'like-remove',
  LikeRemoveOutlineIcon = 'like-remove-outline',
  LockIcon = 'lock',
  LockOutlineIcon = 'lock-outline',
  MembershipRoleIcon = 'membership-role',
  MentionIcon = 'mention',
  MenuIcon = 'menu',
  MessagesIcon = 'messages',
  MicrophoneIcon = 'microphone',
  MicrophoneOutlineIcon = 'microphone-outline',
  NavHighlightBackgroundIcon = 'nav-highlight-background',
  NavHighlightColorIcon = 'nav-highlight-color',
  NavHighlightUnderlineIcon = 'nav-highlight-underline',
  NotificationIcon = 'notification',
  NotificationOutlineIcon = 'notification-outline',
  OverviewStructureIcon = 'overview-structure',
  PanelDividedIcon = 'panel-divided',
  PanelRoundedIcon = 'panel-rounded',
  PanelSpacedIcon = 'panel-spaced',
  PinIcon = 'pin',
  PinOutlineIcon = 'pin-outline',
  PoweredByKhorosLogoIcon = 'powered-by-khoros-logo',
  QuoteIcon = 'quote',
  RankIcon = 'rank',
  RefreshIcon = 'refresh',
  RefreshOutlineIcon = 'refresh-outline',
  RepliesIcon = 'replies',
  RestrictedIcon = 'restricted',
  SearchIcon = 'search',
  SearchOutlineIcon = 'search-outline',
  SearchResultsIcon = 'search-results',
  SectionOneColumnIcon = 'section-1column',
  SectionThreeColumnIcon = 'section-3column',
  SectionTwoColumnIcon = 'section-2column',
  SectionWideLeftIcon = 'section-wide-left',
  SectionWideRightIcon = 'section-wide-right',
  SelectArrowIcon = 'select-arrow',
  SendIcon = 'send',
  SendOutlineIcon = 'send-outline',
  SizeContractIcon = 'size-contract',
  SizeContractOutlineIcon = 'size-contract-outline',
  SizeExpandIcon = 'size-expand',
  SizeExpandOutlineIcon = 'size-expand-outline',
  StarIcon = 'star',
  StarOutlineIcon = 'star-outline',
  StopwatchIcon = 'stopwatch',
  SubtractSolidIcon = 'subtract-solid',
  SubtractSolidOutlineIcon = 'subtract-solid-outline',
  SystemAccountAndPrivacyIcon = 'system-account-and-privacy',
  SystemAdvancedIcon = 'system-advanced',
  SystemAnnouncementsIcon = 'system-announcements',
  SystemAuditIcon = 'system-audit',
  SystemAuthenticationIcon = 'system-authentication',
  SystemAutomationIcon = 'system-automation',
  SystemDisplayIcon = 'system-display',
  SystemRegistrationIcon = 'system-registration',
  SystemSearchIcon = 'system-search',
  SystemSeoIcon = 'system-seo',
  TemplateContentIcon = 'template-content',
  TemplateDashboardIcon = 'template-dashboard',
  TemplateGrouphubsIcon = 'template-grouphubs',
  TemplateHeaderFooterIcon = 'template-header-footer',
  TemplateHomeIcon = 'template-home',
  TemplateProfileIcon = 'template-profile',
  TextAlignCenterIcon = 'text-align-center',
  TextAlignLeftIcon = 'text-align-left',
  TextAlignRightIcon = 'text-align-right',
  ThemeAvatarsIcon = 'theme-avatars',
  ThemeBasicsIcon = 'theme-basics',
  ThemeButtonsIcon = 'theme-buttons',
  ThemeColorsIcon = 'theme-colors',
  ThemeElementsIcon = 'theme-elements',
  ThemeFontsIcon = 'theme-fonts',
  ThemeIconsIcon = 'theme-icons',
  TitleBottomIcon = 'title-bottom',
  TitleOverlayIcon = 'title-overlay',
  TitleTopIcon = 'title-top',
  TrashIcon = 'trash',
  TrashOutlineIcon = 'trash-outline',
  UnfollowIcon = 'unfollow',
  UnfollowOutlineIcon = 'unfollow-outline',
  UserIcon = 'user',
  UserLockedIcon = 'user-locked',
  UserOutlineIcon = 'user-outline',
  UsersAddIcon = 'users-add',
  UsersBadgesIcon = 'users-badges',
  UsersProfileIcon = 'users-profile',
  UsersRanksIcon = 'users-ranks',
  UsersRolesIcon = 'users-roles',
  VideoPlayActiveIcon = 'video-play-active',
  VideoPlayDisabledIcon = 'video-play-disabled',
  ViewsHideIcon = 'views-hide',
  ViewsHideOutlineIcon = 'views-hide-outline',
  ViewsIcon = 'views',
  ViewsOutlineIcon = 'views-outline',
  WidgetContentIcon = 'widget-content',
  WidgetCustomIcon = 'widget-custom',
  WidgetDynamicIcon = 'widget-dynamic',
  WidgetFpoIcon = 'widget-fpo',
  WidgetPeopleIcon = 'widget-people',
  WidgetPlacesIcon = 'widget-places',
  WidgetStaticIcon = 'widget-static',
  ZoomLogoIcon = 'zoom-logo'
}
